import { render, staticRenderFns } from "./CompanyDrawerAdditionalDataTab.vue?vue&type=template&id=5c23b0ff&"
import script from "./CompanyDrawerAdditionalDataTab.vue?vue&type=script&lang=ts&"
export * from "./CompanyDrawerAdditionalDataTab.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDrawerAdditionalDataTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports